export default {
    home: 'Home',
    product: 'Products',
    solutions: 'Solutions',
    service:'Service And Support',
    aboutUs:'About Us'
}